import Firebase from '../../lib/Firebase';
import Firestore from '../../lib/Firestore';


export default {
  all() {
    return (
      Firebase.firestore()
        .collection('hotels')
        //.where('category', '==', category)
        .get()
        .then(docs => {
          return Firestore.getCollectionData(docs);
        })
    );
  },

  //myJSON : JSON.stringify(availableQuantities),

  manageHotel(hotel) {
    const {
      code,
      name,
      state,
      city,
      location,
      pincode,
      star,
      manager,
      m_mobile,
      m_email,
      no,
      email,
      website,
      rooms,
      imageUrl = null,
      active = false
    } = hotel;

    const hotelObj = {
      code,
      name,
      state,
      city,
      location,
      pincode,
      star,
      manager,
      m_mobile,
      m_email,
      no,
      email,
      website,
      rooms,
      imageUrl,
      active
    };
    console.log(hotelObj);
    const promise = hotel.docId
      ? Firebase.firestore()
          .collection('hotels')
          .doc(hotel.docId)
       //   .collection('seasons')
          .update(hotelObj)
      : Firebase.firestore()
          .collection('hotels')
          .add(hotelObj);

    return promise;
  },

  deleteHotel(hotel) {
    return Firebase.firestore()
      .collection('hotels')
      .doc(hotel)
      .delete();
  }
};



// WEBPACK FOOTER //
// ./src/pages/hotels/service.js